import { gql, useQuery } from '@apollo/client'
import cx from 'classnames'
import * as stringify from 'csv-stringify/lib/browser/sync'
import { flatten } from 'lodash'
import * as React from 'react'
import rollbar from '../../helpers/rollbar'

const formatDate = (dateString: string) => new Date(dateString).toLocaleString()

const kitsQuery = gql`
  query KitsForThirdParties($thirdPartyId: ID!) {
    thirdPartyById(id: $thirdPartyId) {
      id

      kits {
        id
        status
        registrationInfo {
          firstName
          lastName
        }
        createdAt
        resultDate
        sku
        result
        thirdPartyResults {
          consentGiven
        }
        order {
          id
          content {
            discounts {
              code
              failureMessage
              amount
            }
          }
        }
      }
    }
  }
`

const KitUsageReport = ({ thirdPartyId }: { thirdPartyId: string }) => {
  const { loading, error, refetch } = useQuery(kitsQuery, {
    skip: true,
    variables: { thirdPartyId },
  })

  const onDownload = async () => {
    try {
      const response = await refetch()

      if (!response.data.thirdPartyById.kits) {
        throw new Error('Unexpected response')
      }

      const csv = stringify(
        flatten(
          response.data.thirdPartyById.kits.map((kit) => ({
            thirdPartyId,
            id: kit.id,
            status: kit.status,
            resultDate: kit.resultDate,
            sku: kit.sku,
            createdAt: kit.createdAt,
            consentGiven: kit.thirdPartyResults?.consentGiven,
            firstName: kit.registrationInfo?.firstName,
            lastName: kit.registrationInfo?.lastName,
          }))
        ),

        { header: true }
      )

      const filename = `KitUsage-${thirdPartyId}-${formatDate(new Date().toISOString())}.csv`

      const blob = new Blob([csv], { type: 'application/csv' })
      const a = document.createElement('a')
      const url = URL.createObjectURL(blob)
      a.href = url
      a.download = filename
      a.onclick = () => {
        setTimeout(() => URL.revokeObjectURL(url), 100)
      }
      a.click()
    } catch (err) {
      console.error(err)
      rollbar.error(err)
      alert(err.message)
    }
  }

  return (
    <>
      <button
        className={cx('button is-primary is-large', { 'is-loading': loading })}
        disabled={loading}
        onClick={onDownload}
      >
        Generate CSV
      </button>
      {error && (
        <article className="message is-danger">
          <div className="message-body">Error: {error.message}</div>
        </article>
      )}
    </>
  )
}

export default KitUsageReport
